var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDownloadIcon = function SvgDownloadIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "main-color-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.125,
    height: 18.125
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 54958"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108511",
    d: "m3.761 8.179 4.78 5.279a.711.711 0 0 0 1 .023l.023-.023 4.8-5.279a.675.675 0 0 0-.906-1l-.091.091-3.625 3.988V.678a.68.68 0 0 0-1.359 0v10.558l-3.6-3.965a.68.68 0 0 0-1.087.816.312.312 0 0 0 .068.091Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108512",
    d: "M17.445 16.766H.68a.68.68 0 0 0 0 1.359h16.765a.68.68 0 0 0 0-1.359Z"
  }))));
};
export default SvgDownloadIcon;